import { createClient, createConfig } from '@hey-api/client-fetch';
export const client = createClient(createConfig());
//# sourceMappingURL=client.gen.js.map